import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import loginHombre from "../../assets/generales/conectapersona.svg";
import conectaLogo from "../../assets/generales/conecta-peru-footer.svg";
import CustomModal from "../../components/CustomModal/CustomModal";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [loginToken, setLoginToken] = useState(null);

  const [showForgotPasswordBlock, setShowForgotPasswordBlock] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [isRequestingReset, setIsRequestingReset] = useState(false);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    message: "",
    type: "",
  });

  const openModal = (title, message, type = "info") => {
    setModalContent({ title, message, type });
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);

    if (
      modalContent.type === "success" &&
      modalContent.title === "Login Exitoso" &&
      loginToken
    ) {
      localStorage.setItem("userToken", loginToken);
      navigate("/welcome");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      openModal(
        "Campos Incompletos",
        "Por favor, ingresa tu usuario/correo y contraseña.",
        "error"
      );
      return;
    }

    setIsLoggingIn(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/loguin/verifay-acount-login`,
        {
          correo: email,
          contrasenia: password,
        }
      );

      if (response.status === 200) {
        const token = response.data.token;
        if (token) {
          setLoginToken(token);
        }

        openModal(
          "Login Exitoso",
          response.data.message ||
            "¡Bienvenido! Has iniciado sesión correctamente.",
          "success"
        );
      }
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Credenciales inválidas o error de conexión. Inténtalo de nuevo.";
      openModal("Error de Login", errorMessage, "error");
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleForgotPasswordRequest = async (e) => {
    e.preventDefault();

    if (!forgotPasswordEmail) {
      openModal(
        "Campo Vacío",
        "Por favor, ingresa tu correo electrónico.",
        "error"
      );
      return;
    }

    setIsRequestingReset(true); // Activa el estado de carga
    try {
      const response = await axios.post(`${API_BASE_URL}/loguin/olvide-email`, {
        correo: forgotPasswordEmail,
      });

      if (response.status === 200) {
        openModal(
          "Correo Enviado",
          response.data.message ||
            "Se ha enviado un enlace/instrucciones de restablecimiento a tu correo.",
          "success"
        );
        setForgotPasswordEmail(""); // Limpia el campo
        setShowForgotPasswordBlock(false); // Vuelve al formulario de login
      }
    } catch (error) {
      console.error(
        "Error al solicitar restablecimiento de contraseña:",
        error
      );
      const errorMessage =
        error.response?.data?.message ||
        "No se pudo procesar tu solicitud. Asegúrate de que el correo sea correcto y inténtalo de nuevo.";
      openModal("Error al Restablecer", errorMessage, "error");
    } finally {
      setIsRequestingReset(false); // Desactiva el estado de carga
    }
  };

  return (
    <div className="login-root row g-0 min-vh-100">
      <div className="col-md-6 d-none d-md-block login-img-col p-0">
        <img
          src={loginHombre}
          alt="Login ilustración"
          className="login-img w-100 h-100"
        />
      </div>

      <div className="col-12 col-md-6 d-flex align-items-center justify-content-center login-form-bg">
        <div className="login-form-box w-100">
          <div className="text-center mb-4">
            <Link to="/">
              <img
                src={conectaLogo}
                alt="Conéctate Perú"
                className="login-title-img mb-3"
              />
            </Link>

            <div className="login-facebook-icon mx-auto mb-3">
              <div className="mt-2 d-flex gap-2">
                <a
                  href="https://www.facebook.com/"
                  target="_black"
                  className="footer-social footer-social-facebook"
                  aria-label="Facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>
              </div>
            </div>
            <h2 className="login-heading mb-4">
              {showForgotPasswordBlock
                ? "Recuperar Contraseña"
                : "Inicia sesión"}
            </h2>
          </div>

          {!showForgotPasswordBlock ? (
            <form onSubmit={handleLogin}>
              <div className="form-floating mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="floatingInputEmail"
                  placeholder="name@example.com"
                  autoComplete="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="floatingInputEmail">Correo Electrónico</label>
              </div>

              <div className="form-floating mb-2">
                <input
                  type="password"
                  className="form-control"
                  id="floatingInputPassword"
                  placeholder="Contraseña"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <label htmlFor="floatingInputPassword">Contraseña</label>
              </div>

              <div className="mb-3 text-end">
                <button
                  type="button"
                  className="btn btn-link p-0 align-baseline login-link-small"
                  onClick={() => setShowForgotPasswordBlock(true)}
                >
                  ¿Olvidaste tu usuario y/o contraseña?
                </button>
              </div>

              <div className="d-grid mb-3">
                <button
                  type="submit"
                  className="btn-login-aceptar"
                  disabled={isLoggingIn}
                >
                  {isLoggingIn ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {" Iniciando Sesión..."}
                    </>
                  ) : (
                    "Aceptar"
                  )}
                </button>
              </div>

              <div className="text-center">
                <Link to="/registrarme" className="login-link-register">
                  Registrarme
                </Link>
              </div>
            </form>
          ) : (
            <form onSubmit={handleForgotPasswordRequest}>
              <p className="text-center mb-4">
                Ingresa el correo electrónico asociado a tu cuenta para recibir
                instrucciones de recuperación.
              </p>
              <div className="form-floating mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="forgotPasswordEmail"
                  placeholder="name@example.com"
                  value={forgotPasswordEmail}
                  onChange={(e) => setForgotPasswordEmail(e.target.value)}
                  required
                />
                <label htmlFor="forgotPasswordEmail">Correo Electrónico</label>
              </div>
              <div className="d-grid mb-3">
                <button
                  type="submit"
                  className="btn-login-aceptar"
                  disabled={isRequestingReset}
                >
                  {isRequestingReset ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {" Enviando Correo..."}
                    </>
                  ) : (
                    "Recibir Correo"
                  )}
                </button>
              </div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-link p-0 align-baseline login-link-small"
                  onClick={() => setShowForgotPasswordBlock(false)}
                >
                  Volver al inicio de sesión
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      <CustomModal
        isOpen={modalIsOpen}
        title={modalContent.title}
        message={modalContent.message}
        type={modalContent.type}
        onClose={closeModal}
      />
    </div>
  );
};

export default Login;
